import { ElementState } from "@creatomate/preview";


const getSectionElementByIndex = (
  index: number,
  elements?: ElementState[]
): ElementState | undefined => (
  elements?.find(element => {
    // name format sub-INDEX-creatomateId
    const match = element.source.name?.match(/sub-(\d{1,4})-/);
    if (!match) return false;

    const sectionIndex = parseInt(match[1], 10);
    return sectionIndex === index;
  })
);

export default getSectionElementByIndex;
